import { FirebaseError } from '../../../types/errors'

const validateLoginForm = (email: string, password: string): string | null => {
  if (!email || !password) {
    return 'Please fill in all fields'
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address'
  }

  return null
}

const getErrorMessage = (error: FirebaseError): string => {
  // Firebase error handling
  if (error.code) {
    switch (error.code) {
      case 'auth/invalid-email':
        return 'Invalid email address'
      case 'auth/user-disabled':
        return 'This account has been disabled'
      case 'auth/user-not-found':
        return 'No account found with this email'
      case 'auth/wrong-password':
        return 'Incorrect password'
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Please try again later'
      default:
        return error.message || 'Failed to sign in'
    }
  }

  return error.message || 'Failed to sign in'
}

export { validateLoginForm, getErrorMessage }
